module.exports = __webpack_public_path__ + "img/page-not-found.ffadd160.png";